<section class="vl-region">
  <div class="vl-layout">
    <div class="vl-title-wrapper vl-title-wrapper--h2 vl-title-wrapper--cta">
      <h2
        class="vl-title vl-title--h2 vl-title-wrapper__title vl-title-wrapper--cta__title"
      >
        Overzicht prikcampagnes - densiteitsmetingen
      </h2>
      <mdk-delete-confirmation-survey-campaign-modal
        [identifier]="'delete-confirmation-survey'"
        #DeleteConfirmationSurveyCampaignModal
        (campaignDeleted)="handleCampaignDeleted()"
      >
      </mdk-delete-confirmation-survey-campaign-modal>
      <mdk-create-survey-campaign-modal
        [identifier]="'create-survey'"
        #CreateSurveyCampaignModal
      >
      </mdk-create-survey-campaign-modal>
      <button
        type="button"
        class="vl-button--naked-action vl-button--icon-before"
        (click)="createNewSurveyCampaign()"
        vl-button
      >
        <i
          class="vl-button__icon vl-button__icon--before vl-vi vl-vi-add"
          aria-hidden="true"
        ></i>
        <span class="vl-button__label">Nieuwe prikcampagne</span>
      </button>
    </div>
    <div class="vl-u-table-overflow">
      <table #dataTable data-table class="vl-data-table vl-data-table--hover">
        <thead>
          <tr>
            <th>Naam campagne</th>
            <th aria-label="Startdatum in UTC-tijdzone">Startdatum</th>
            <th>Zone</th>
            <th>Status</th>
            <th><span class="vl-u-visually-hidden">Acties</span></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let campaign of campaigns$ | async;"
            data-row-selectable
            data-vl-table-selectable
            [routerLink]="['/detail-survey-campaign/', campaign.id]"
          >
            <td data-title="Naam campagne">{{campaign.campaignName}}</td>
            <td data-title="Startdatum">
              <time [attr.datetime]="campaign.startDate"
                >{{ campaign.startDate | date:'dd/MM/yyyy':'+0000':'nl-BE'
                }}</time
              >
            </td>
            <td data-title="Zone">{{campaign.zone}}</td>
            <td
              data-title="Status"
              class="vl-data-table__element--{{tableItemClassHelper(campaign.state)}}"
            >
              {{campaign.state}}
            </td>
            <td data-title="Acties" (click)="$event.stopPropagation()">
              <div class="vl-action-group vl-action-group--align-center">
                <a
                  *ngIf="hasDeleteSurveyCampaignAction(campaign.links)"
                  class="vl-link"
                  (click)="handleRemoveCampaign($event, campaign.id, campaign.links)"
                >
                  <span class="vl-u-visually-hidden">Verwijder campagne</span>
                  <span
                    class="vl-link__icon vl-link__icon--standalone vl-vi vl-vi-bin"
                  ></span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
